/**
 * PHOTOS (docs/milestones/PHOTOS-contracts.md): the shared vocabulary of the picture taken as a ranger falls.
 * server/photoCheck.mjs holds the same numbers; a test keeps the two together.
 */

/** The game's own picture, exactly: the internal frame, no HUD (the HUD is DOM over the canvas). */
export const PHOTO_W = 640;
export const PHOTO_H = 360;
/** The most a photo may weigh, bytes. The encoder steps its quality down until the JPEG fits; the server refuses more. */
export const MAX_PHOTO_BYTES = 80 * 1024;
/** How many pictures one save keeps, newest first, on the device and on the server alike. */
export const MAX_PHOTOS_KEPT = 40;

/** A photo id: lower-case letters and digits, 12 to 32 of them. Minted on the device (`newPhotoId`). */
export const PHOTO_ID = /^[a-z0-9]{12,32}$/;

export function isPhotoId(id: unknown): id is string {
  return typeof id === 'string' && PHOTO_ID.test(id);
}

/**
 * What the mission loop is handed (`startMission` options `camera`), only in a mode that puts a name on the
 * Memorial Wall (an operation or Classic - never practice, training or the Daily Drop).
 */
export interface DeathCamera {
  /**
   * Take the picture NOW, at the moment the mission hands over after a death. `pixels` reads the post-pass
   * frame (`RenderPipeline.readPixels`: RGBA8, bottom row first, 642 x 362 with a 1-texel border), and is
   * called at once, synchronously, before anything else is drawn. Returns the new photo's id straight away
   * (the JPEG is encoded, stored and uploaded after), or null when no picture could be taken. Never throws.
   */
  take(pixels: () => Uint8Array): string | null;
}
